import { Outlet } from 'react-router-dom'

const ReportPnbp = () => {
  return <Outlet />
}

export default ReportPnbp
